import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ValidationMessage from '../../components/validation/ValidationMessage';
import Logo from '../../components/login/logo';
import SocialAuth from '../../components/socialAuth';
import './style.css';
import Cover from '../../components/login/cover';

const buttons = ({ canRegister, t }) => (
  <ul>
    {canRegister && (
      <li>
        <Link to="/register">{t('Create account')}</Link>
      </li>
    )}
    <li className={canRegister ? '' : 'login-additional-box-only-register'}>
      <Link to="/forgot-password">{t('Forgot password?')}</Link>
    </li>
  </ul>
);

const loginFields = ({ formData, onChange, t, isBanned, valid, wasValidated, canRegister }) => (
  <React.Fragment>
    <div className="logininput boxs">
      <input
        name="username"
        type="text"
        placeholder={t('Email')}
        className="form-control form-controllogin"
        value={formData.username}
        onChange={onChange}
      />
    </div>
    <div className="logininput boxs">
      <input
        type="password"
        name="password"
        placeholder={t('Password')}
        className="form-control form-controllogin"
        value={formData.password}
        onChange={onChange}
      />
      <ValidationMessage message={!isBanned ? t('Invalid credentials') : t('Too many unsuccessful attempts')} valid={valid} wasValidated={wasValidated} />
    </div>
    <div className="loginbtnouter boxs">
      <button className="loginbtn" type="submit">
        {t('Login')}
      </button>
    </div>
    {canRegister && <SocialAuth login /> }
  </React.Fragment>
);

const Login = ({
  t,
  valid,
  isBanned,
  formData,
  onChange,
  onSubmit,
  canRegister,
  loginColor,
  socialLoginLayout,
  loginLayout,
  coverLogin,
  slogan,
  wasValidated,
}) => (
  <div>
    {(function() {
      switch (loginLayout) {
        case 2:
          return (
            <section className="Login  boxs relative">
              <div className={loginColor}>
                <Cover likeBachground={false} />
                <div className="alt2 leftinner absolute tc" style={{ padding: '40px', height: socialLoginLayout == 2 ? '43em' : '36em' }}>
                  <div className={`loginformwidth`}>
                    <div className="loginbox tc">
                      <Logo />
                      <p className="fontmulisemi" style={{ 'font-size': '18px' }}>{slogan || t('Default slogan')}</p>
                      <div className="loginform loginform2 boxs">
                        <form onSubmit={onSubmit}>
                          {loginFields({ formData, onChange, t, isBanned, valid, wasValidated, canRegister })}
                          <div className="crtaccfrgtpasbox crtaccfrgtpasbox2 boxs" style={{ padding: '15px 0' }}>
                            {buttons({ canRegister, t })}
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          );
        case 3:
          return (
            <div className={loginColor}>
              <section className="Login alt1 tc">
                <div className="leftinner w-full">
                  <div className="loginformwidth">
                    <div className="loginbox boxs">
                      <Logo />
                      <p className="fontmulisemi">{slogan || t('Default slogan')}</p>
                      <div className="loginform loginform2 boxs">
                        <form onSubmit={onSubmit}>
                          {loginFields({ formData, onChange, t, isBanned, valid, wasValidated, canRegister })}
                          <div className="crtaccfrgtpasbox crtaccfrgtpasbox2 boxs">
                            {buttons({ canRegister, t })}
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          );
        default:
          return (
            <section className="Login boxs">
              <div className={`loginleftw ${loginColor}`}>
                <div className="leftinner tc">
                  <div className="loginformwidth">
                    <div className="loginbox boxs">
                      <Logo />
                      <p className="fontmulisemi">{slogan || t('Default slogan')}</p>
                      <div className="loginform boxs">
                        <form onSubmit={onSubmit}>
                          {loginFields({ formData, onChange, t, isBanned, valid, wasValidated, canRegister })}
                          <div className="crtaccfrgtpasbox boxs login-additional-box ">
                            {buttons({ canRegister, t })}
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Cover />
            </section>
          );
      }
    })()}
  </div>
);

Login.propTypes = {
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  valid: PropTypes.bool.isRequired,
  wasValidated: PropTypes.bool.isRequired,
  isBanned: PropTypes.bool.isRequired,
  formData: PropTypes.object.isRequired,
  loginColor: PropTypes.string,
};

export default Login;



// WEBPACK FOOTER //
// ./src/views/login/Login.jsx